import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { printToolSetWeek, setFlyerCurrentWeek } from '../../../actions'
import { FEATURES, PRINT_WEEKS } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'
import ChooseWeek from '../present/ChooseWeek'
import { FLYER, SHOWCASE, WEEKPOSTER } from '../../../constants/printType'

const mapStateToProps = state => ({
    weeks: getData(state, PRINT_WEEKS),
    features: getData(state, FEATURES)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    printToolSetWeek: (week) => {
        if(SHOWCASE === ownProps.printType || WEEKPOSTER === ownProps.printType) {
            dispatch(printToolSetWeek(week))
        } else if (FLYER === ownProps.printType) {
            dispatch(setFlyerCurrentWeek(week))
        }
    }
})

const ChooseWeekContainer = ({
    cinemaId,
    printType, 
    printID, 
    landscape,
    features, 
    weeks, 
    week,
    closePagePath,
    printToolSetWeek
}) => {
    return <ChooseWeek
        features={features}
        cinemaId={cinemaId}
        printType={printType}
        printID={printID}
        landscape={landscape}
        weeks={weeks}
        activeWeek={week}
        closePagePath={closePagePath}
        printToolSetWeek={printToolSetWeek}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ChooseWeekContainer)